import createReducer from '@monorepo/core/utils/createReducer'
import { ReducerRecord } from './records'

import { initialState } from 'App/data/company'

export const companyReducer = createReducer(
  { data: ReducerRecord(initialState) },
  {}
)
